module.exports = __webpack_public_path__ + "static/media/Product-tabicon2.4a4bb723.png";